<template>
  <v-container fluid>
    <v-toolbar flat>
      <v-btn icon>
        <v-icon large>mdi-view-dashboard</v-icon>
      </v-btn>

      <v-toolbar-title class="text-h4">{{ $t("DASHBOARD") }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- <v-btn icon>
        <v-icon>mdi-heart</v-icon>
      </v-btn>

      <v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn> -->
    </v-toolbar>
    <v-card flat class="mx-4 my-5">
      <!-- {{ process }} -->
      <v-row>
        <template v-for="item in cards">
          <v-col cols="12" md="6" lg="3" :key="item.title">
            <dash-card
              :title="item.title"
              :subtitle="item.subtitle"
              :color="item.color"
              :link="item.link"
              :value="item.value"
              :config="item"
              :key="item.name"
            ></dash-card>
          </v-col>
        </template>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Dashboard",
  route: {
    path: "/dashboard",
    name: "Dashboard",
  },
  data() {
    return {
      cards: [
        {
          title: "Contacts",
          subtitle: "Total Contacts",
          color: "#EE3D42",
          link: "/contacts",
          icon: "mdi-contacts",
          value: this.$app.data.contacts.length || 0,
          action: null,
        },
        {
          title: "Games",
          subtitle: "All Managed Games",
          color: "#0069AA",
          link: "/games",
          icon: "mdi-gamepad",
          value: this.$app.data.games.length || 0,
          action: null,
        },
        {
          title: "Forms",
          subtitle: "Smart Sheet Forms",
          color: "#008751",
          link: "/smart-forms",
          icon: "mdi-file-document-multiple-outline",
          value: this.$app.data.smartForms.length || 0,
          action: null,
        },
        {
          title: "Organizations",
          subtitle: "All Organizations/Groups",
          color: "#BF311A",
          link: "",
          icon: "mdi-domain",
          value: this.$app.data.organizations.length || 0,
          action: null,
        },
      ],
    };
  },
  components: {
    DashCard: () => import("./components/DashCard.vue"),
  },
  computed: {
    appData(key) {
      let data = key ? this.$app.data[key] : this.$app.data;
      return data;
    },
    // process: () => {
    //   return this.process.env.NODE_ENV;
    // },
  },
  mounted() {
    //console.log("process", process.env.NODE_ENV);
  },
};
</script>

<style></style>
